<template>
  <transition name="fade" mode="out-in" appear :duration="500">
    <div>
      <a
        class="button block interactive"
        :class="{ 'outline-black': type === 'recce', primary: type === 'booking' }"
        @click="isLoggedIn ? openBookingForm() : showAction()"
      >
        {{ type === "recce" ? "Schedule a Recce" : "Get a Quote" }}
      </a>

      <div class="inner" v-if="showLoginDropDown">
        <ul class="listing shortlists shortlists--custom">
          <li class="shortlist-action" @click="showLogin">
            <svg-icon id="signIn"></svg-icon>
            <span>Log In </span>
          </li>
          <li class="shortlist-action" @click="showSignup">
            <svg-icon id="signUp"></svg-icon>
            <span>Sign Up For Free</span>
          </li>
        </ul>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  props: {
    listing: {
      type: Object,
      required: true,
    },
    type: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      showLoginDropDown: false,
      triggeredAuth: false,
    };
  },
  mounted() {
    window.addEventListener("click", this.delegatedHideBook);
  },
  beforeDestroy() {
    window.removeEventListener("click", this.delegatedHideBook);
  },
  methods: {
    openBookingForm() {
      if (!window.location.href.includes("#" + this.type)) {
        window.history.pushState(
          "booking",
          "url",
          window.location.href + "#" + this.type
        );
      }
      this.$store
        .dispatch("modals/show", {
          title: this.title,
          type: "listing-book",
          maskCanDismiss: false,
          data: {
            listing: this.listing,
            type: this.type,
          },
        })
        .then(() => {})
        .catch(() => {});
    },
    showLogin() {
      this.triggeredAuth = true;
      this.$store.commit("user/changeAuthMode", {
        which: "login",
        priority: true,
      });
    },
    showSignup() {
      this.triggeredAuth = true;
      this.$store.commit("user/changeAuthMode", {
        which: "signup",
        priority: true,
      });
    },
    showAction() {
      this.showLoginDropDown = !this.showLoginDropDown;
    },
    delegatedHideBook(e) {
      let target = e.target;

      while (target.parentNode) {
        if (target === this.$el) {
          return;
        }

        target = target.parentNode;
      }

      this.showLoginDropDown = false;
    },
  },
  computed: {
    authenticating() {},
    title() {
      return this.type === "recce"
        ? `<div class="booking-title">Schedule a Recce at</div><div class="booking-space-name">${this.listing.space_name}</div>`
        : `<div class="booking-title">Get a Quote for</div><div class="booking-space-name">${this.listing.space_name}</div>`;
    },
    isLoggedIn() {
      var loggedInObj = this.$store.getters["user/account"];
      this.showLoginDropDown =
        typeof loggedInObj === "object" ? false : this.showLoginDropDown;
      return loggedInObj;
    },
  },
  watch: {
    authenticating(now) {
      if (!now && this.triggeredAuth && !this.isLoggedIn) {
        this.triggeredAuth = false;
      }
    },
    isLoggedIn(now) {
      if (now && this.triggeredAuth) {
        this.$store.commit("account/hide");
        this.triggeredAuth = false;
        this.showLoginDropDown = false;
      }
    },
  },
};
</script>
